import { Component, OnDestroy, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import * as moment from 'moment';
import { Subscription, interval, takeUntil, takeWhile } from 'rxjs';
import { DashboardCard } from 'src/app/core/models/dashboard.card.model';
import { DashboardCardResponse } from 'src/app/core/models/response/dashboard-cards.model';
import { DashboardLocalizacaoResponse } from 'src/app/core/models/response/dashboard-localizacao.model';
import { DashboardMovimentoResponse } from 'src/app/core/models/response/dashboard-movimento.model';
import { WeblabService } from 'src/app/core/services/weblab.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  cards: Array<DashboardCard>;
  basicData: any;
  basicOptions: any;
  data: any;
  options: any;
  // interval$: Subscription;
  intervallTimer = interval(1000 * 60); //1 minuto
  refreshAtivo = true;
  refreshIniciado: boolean = false;

  responsiveOptions: any[] | undefined;

  busyCards: boolean = false;
  busyLocalizacoes: boolean = false;
  busyMovimentacoes: boolean = false;

  // chartHeight: number;

  lblLocalizacoes: string[] = [];
  vlrLocalizacoes: number[] = [];

  lblMovimentacoes: string[] = [];
  vlrMovimentacoesValidacao: number[] = [];
  vlrMovimentacoesProducao: number[] = [];
  vlrMovimentacoesAprovados: number[] = [];
  vlrMovimentacoesEntregues: number[] = [];
  vlrMovimentacoesCancelados: number[] = [];

  constructor(private service: WeblabService) { }

  ngOnInit(): void {
    // this.chartHeight = window.innerHeight / 2;

    this.carregaDashboard();

    this.responsiveOptions = [
      {
        breakpoint: '1199px',
        numVisible: 3,
        numScroll: 1
      },
      {
        breakpoint: '991px',
        numVisible: 3,
        numScroll: 1
      },
      {
        breakpoint: '767px',
        numVisible: 2,
        numScroll: 1
      }
    ];

    setTimeout(() => {
      this.refreshIniciado = true;
      this.iniciandoRefresh();
    }, 1000);
  }

  ngOnDestroy(): void {
    this.refreshAtivo = false;
  }

  iniciandoRefresh() {

    this.intervallTimer.pipe(
      takeWhile(() => this.refreshAtivo)
    ).subscribe(() => {
      this.carregaDashboard();
    });
  }

  carregaDashboard() {
    this.buscaCards();
  }

  private buscaCards() {
    //Cards
    this.busyCards = !this.refreshIniciado ? true : false;
    const cards$ = this.service.dashboardCards();
    cards$.subscribe({
      next: (resp: DashboardCardResponse) => this.cardSucesso((resp as any).dados),
      error: (error: any) => this.cardErro(error)
    });
  }

  private cardSucesso(cards: DashboardCardResponse) {
    this.carregaCards(cards);
    this.busyCards = false;
    this.buscaLocalizacoes();
  }

  private cardErro(error: any) {
    this.busyCards = false;
    this.buscaLocalizacoes();
  }

  private buscaLocalizacoes() {
    // Grafico 1
    this.busyLocalizacoes = !this.refreshIniciado ? true : false;
    const localizacoes$ = this.service.dashboardLocalizacoes();
    localizacoes$.subscribe({
      next: (resp: DashboardLocalizacaoResponse) => this.localizacoesSucesso(resp),
      error: (error: any) => this.localizacoesErro(error)
    });
  }

  private localizacoesSucesso(localizacoes: DashboardLocalizacaoResponse) {
    this.lblLocalizacoes = [];
    this.vlrLocalizacoes = [];

    localizacoes.dados.locations?.sort((a, b) => {
      const nameA = a.localizacao.replace(/\s/g, "").toUpperCase();
      const nameB = b.localizacao.replace(/\s/g, "").toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    });

    localizacoes.dados.locations.forEach(localizacao => {
      this.lblLocalizacoes.push(localizacao.localizacao);
      this.vlrLocalizacoes.push(localizacao.quantidade);
    });

    this.carregaGraficoLocalizacoes();
    this.busyLocalizacoes = false;
  }

  private localizacoesErro(error: any) {
    this.busyLocalizacoes = false;
  }

  carregaCards(cards: any) {
    this.cards = [
      {
        title: 'Em Progresso',
        icon: 'pi-cog',
        class: 'bg-primary',
        valor: cards.em_progresso,
        filters: {
          status: 'Produção'
        }
      },
      {
        title: 'Atrasados',
        icon: 'pi-info-circle',
        class: 'bg-secondary2',
        valor: cards.atrasadas,
        filters: {
          status: 'Atrasados'
        }
      },
      {
        title: 'Entregues Hoje',
        icon: 'pi-car',
        class: 'bg-primary3',
        valor: cards.entregas_hoje,
        filters: {
          status: 'Entregues',
          startDate: moment().startOf("day").format('YYYY-MM-DD 00:00:00')
        }
      },
      {
        title: 'Vendidas Hoje',
        icon: 'pi-car',
        class: 'bg-primary3',
        valor: cards.vendidas_hoje,
        filters: {
          status: 'Entregues',
          startDate: moment().startOf("day").format('YYYY-MM-DD 00:00:00'),
          endDate: moment().endOf("day").format('YYYY-MM-DD 23:59:59')
        }
      },
      {
        title: 'Cancelados/mês',
        icon: 'pi-times-circle',
        class: 'bg-secondary',
        valor: cards.canceladas_mes,
        filters: {
          status: 'Cancelados',
          // startDate: moment().startOf('month').format('YYYY-MM-DD 00:00:00'),  
          // endDate: moment().endOf('month').format('YYYY-MM-DD 23:59:59'),  
        }
      },
    ];
  }

  private newLegendClickHandler = function (e: any, legendItem: any, legend: any) {
    // const index = legendItem.datasetIndex;
    // const ci = legend.chart;
    // if (ci.isDatasetVisible(index)) {
    //   ci.hide(index);
    //   legendItem.hidden = true;
    // } else {
    //   ci.show(index);
    //   legendItem.hidden = false;
    // }
  };

  carregaGraficoLocalizacoes() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.basicData = {
      labels: this.lblLocalizacoes,
      datasets: [
        {
          label: 'Pedidos',
          data: this.vlrLocalizacoes,
          backgroundColor: ['rgba(255, 159, 64, 0.2)', 'rgba(75, 192, 192, 0.2)', 'rgba(54, 162, 235, 0.2)', 'rgba(153, 102, 255, 0.2)'],
          borderColor: ['rgb(255, 159, 64)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)'],
          borderWidth: 1
        }
      ]
    };

    this.basicOptions = {
      responsive: true,
      plugins: {
        legend: {
          // display: true,
          // position: 'top',
          // align: 'center',
          labels: {
            color: textColor,
            // boxWidth: 13,
            // textAlign: 'left',
            // padding: 3,
          },
          title: {
            display: true,
            color: textColor,
            text: 'Status das vendas',
            font: {
              size: 13,
              weight: 'bold'
            }
          },
          onClick: this.newLegendClickHandler
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        x: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        }
      }
    };
  }
}